import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { isEmpty,some } from 'lodash';
import React from 'react';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist/legacy/build/pdf';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

import './PersonalInformation.css';
import StepForm from "../state-transition/StateTransition";

import formValidatorService from './../../services/form.validator.service';
import UtilityService from './../../services/utility.service';
import {
    setCurrentUserData,
    setShowLoaderStatus,
    setPersonalInfoData,
    savePersonalInfo,
    setTransactionId,
    getExamCenters,
    getInstitutions,
    resetPersonalInfoData,
    restExamDetails,
    restInstitutionDetails,
    setNamesFromHistoryAndModified    
} from './../../redux-building-blocks/actions';
const faUploadV5 = { 
    prefix: 'fas', 
    iconName: 'upload',
    icon: [512, 512, [], 'f093', 'M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24z'] 
};

GlobalWorkerOptions.workerSrc = `pdf.worker.min.js`;

export class PersonalInformationComp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName:'',
            lastName:'',
            email:'',
            fileName: '', file: [],
            otherFirstName: '', otherLastName: '', dateOfBirth: {
                day: '', month: '', year: ''
            },
            zipCode:'',
            errors: {
                file: {},
                firstName: {},
                lastName: {},
                email: {},
                otherFirstName: {},
                otherLastName: {},
                dateOfBirth: {},
                zipCode:{},
                day: {},
                month: {},
                year: {}
            },
            isDirtyInput: {
                file: false,
                firstName: true,
                lastName: true,
                email: true,
                otherFirstName: false,
                otherLastName: false,
                dateOfBirth: false,
                zipCode: false,
                day: false,
                month: false,
                year: false
            },
            previewSrc: '',
            isCorruptedImg: false,
            pdfSrc: '',
            isCorruptedPdf: false
        }
        this.canvasRef = React.createRef();
        this.renderTask = null;
    }
    getPersonalInformationFromSAPCDC(){
        const {userProfile,modifiedNames} = this.props;        
        return{
            firstName:!isEmpty(modifiedNames.fNameFromHistory)?modifiedNames.fNameFromHistory:userProfile?.given_name,
            lastName:!isEmpty(modifiedNames.lNameFromHistory)?modifiedNames.lNameFromHistory:userProfile?.family_name,
            email:userProfile?.email
        }
    }
    componentDidMount() {
    
        this.setState((state, props) => ({
            ...this.getPersonalInformationFromSAPCDC(),
           ...this.setPersonalInfoFromApplication(props)
        }));
        const file = this.props.userAppProfileData?.file;
        if(file && file instanceof Blob){
            if(file.type === 'application/pdf') {
                const pdfURL = URL.createObjectURL(file);
                this.setState({ pdfSrc: pdfURL });
                this.loadPDF(pdfURL, false);
            }else {
                const imgURL = URL.createObjectURL(file);
                this.setState({ previewSrc: imgURL }) 
            }
        }
        if(isEmpty(this.props.userProfile) && this.props.UID) {
            this.props.setShowLoaderStatus(true);
        }
        if(isEmpty(this.props.transactionId)) {
            this.props.setTransactionId(uuidv4());
        }

        // initiating centre,institution api call if this value is empty
        if(isEmpty(this.props.examCenterList)) {
            this.props.getExamCenters();
        }

        if(isEmpty(this.props.institutionList)) {
            this.props.getInstitutions();
        }              
    }

    componentWillUnmount() {
        if (this.renderTask) {
            this.renderTask.cancel();
        }
        const canvas = this.canvasRef.current;
        if (canvas) {
            const context = canvas.getContext('2d');
            context.clearRect(0, 0, canvas.width, canvas.height);
        }
    }

    loadPDF = async (pdfURL, isUpload) => {
        try {
            const loadingTask = getDocument(pdfURL);
            const pdf = await loadingTask.promise;
            const canvas = this.canvasRef.current;
            await this.renderPDFPage(pdf, canvas, 1);
        } catch (error) {
            if(isUpload){
                this.setState({ file: [], isCorruptedPdf: true });
            }
        }
    };

    setPersonalInfoFromApplication(props) {
        return {
            fileName: props.userAppProfileData.fileName,
            file: props.userAppProfileData.file,
            otherFirstName: props.userAppProfileData.otherFirstName,
            otherLastName: props.userAppProfileData.otherLastName,
            dateOfBirth: props.userAppProfileData.dateOfBirth,
            zipCode: props.userAppProfileData.zipCode
        }
    }

    renderPDFPage = async (pdf, canvas, pageNumber) => {
        if (this.renderTask) {
            this.renderTask.cancel();
        }

        try {
            const page = await pdf.getPage(pageNumber);
            const context = canvas.getContext('2d');
            context.clearRect(0, 0, canvas.width, canvas.height);
            const scale = 1.5;
            const viewport = page.getViewport({ scale });
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            canvas.style.border = '1px solid #000';
            this.renderTask = page.render({ canvasContext: context, viewport });
            await this.renderTask.promise;
        } catch (error) {
            // console.log(error);
        }
    };

    handleNameChange(event) {
        const validatorError = formValidatorService.validate(event.target.value,
            ['required']);
        this.setErrorAndDirtyFlag(validatorError, 'firstName');

        this.setState({firstName: event.target.value});
    }
    handleLastNameChange(event) {
        const validatorError = formValidatorService.validate(event.target.value,
            ['required']);
        this.setErrorAndDirtyFlag(validatorError, 'lastName');

        this.setState({
                lastName: event.target.value});
    }

    handleOtherFirstNameChange(event) {
        this.setState({otherFirstName: event.target.value});
        this.setState({isDirtyInput: {...this.state.isDirtyInput, otherFirstName: true}});
    }

    handleOtherLastNameChange(event) {
        this.setState({otherLastName: event.target.value});
        this.setState({isDirtyInput: {...this.state.isDirtyInput, otherLastName: true}});
    }

    handleZipCodeChange(event) {       
        this.setState({zipCode: event.target.value});               
    }

    showErrMsgs(event){
        const ZipCodeFormatError = formValidatorService.validate(event.target.value,
            ['required','zipCode']);
        this.setErrorAndDirtyFlag(ZipCodeFormatError, 'zipCode'); 
    }

    handleEmailChange(event) {
        this.setState({email: event.target.value});
    }


    handleBirthDayChange(event) {
        const validatorError = formValidatorService.validate(event.target.value,
            ['required']);
        this.setErrorAndDirtyFlag(validatorError, 'day');

        this.setState({dateOfBirth: {...this.state.dateOfBirth, day: event.target.value}},
            () => {
                this.checkDOB();
            });
    }
    handleBirthMonthChange(event) {
        const validatorError = formValidatorService.validate(event.target.value,
            ['required']);
        this.setErrorAndDirtyFlag(validatorError, 'month');

        this.setState({dateOfBirth: {...this.state.dateOfBirth, month: event.target.value}},
            () => {
                this.checkDOB();
            });
    }
    handleBirthYearChange(event) {
        const validatorError = formValidatorService.validate(event.target.value,
            ['required']);
        this.setErrorAndDirtyFlag(validatorError, 'year');

        this.setState({dateOfBirth: {...this.state.dateOfBirth, year: event.target.value}},
            () => {
                this.checkDOB();
            });
    }


    handleFileUpload = event => {
        document.getElementById("fileupload").click()
    };

    handleChange(event) {
        this.setState({ previewSrc: '', isCorruptedImg: false, pdfSrc: '', isCorruptedPdf: false })
        const validatorError = formValidatorService.validate(event.target.files,
            ['profileFileType', 'fileSizeCheck','emptyFileCheck']);
        this.setErrorAndDirtyFlag(validatorError, 'file');

        this.setState({ fileName: (event.target.files[0] && event.target.files[0].name) ?
                event.target.files[0].name : '', file: event.target.files[0]});
        const file = event.target.files[0];
        if(file) {
            const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp']
            if(validTypes.includes(file.type)){
                const imgURL = URL.createObjectURL(file);
                this.setState({ previewSrc: imgURL })
                const img = new Image();
                img.src = imgURL;
                img.onerror = () => {
                    this.setState({ file: [], isCorruptedImg: true })
                };
            }else if(file.type === 'application/pdf'){
                const pdfURL = URL.createObjectURL(file);
                this.setState({ pdfSrc: pdfURL })
                this.loadPDF(pdfURL, true);
            }
        }
    }

    handlePreview(e){
        e.preventDefault();
        if (this.state.previewSrc){
            window.open(this.state.previewSrc, "_blank")
        }else if (this.state.pdfSrc){
            window.open(this.state.pdfSrc, "_blank")
        }
    }

    handleSubmit(event) {
        const validatorErrorFile = formValidatorService.validate(this.state.fileName,
            ['required']);

        const validatorErrorDay = formValidatorService.validate(this.state.dateOfBirth.day,
            ['required']);

        const validatorErrorMonth = formValidatorService.validate(this.state.dateOfBirth.month,
            ['required']);


        const validatorErrorYear = formValidatorService.validate(this.state.dateOfBirth.year,
            ['required']);

        const zipCodeFormatError = formValidatorService.validate(this.state.zipCode,
            ['zipCode']);

        this.setState({errors: {...this.state.errors,
                file: (isEmpty(validatorErrorFile[0]))
                    ? this.state.errors.file : validatorErrorFile[0],
                day: validatorErrorDay[0],
                month: validatorErrorMonth[0],
                year: validatorErrorYear[0],
                zipCode: !this.state.zipCode.length ?{required: true}:zipCodeFormatError[0]

            }}, () => {
            this.setState({isDirtyInput: {...this.state.isDirtyInput,
                    year: true,
                    month: true,
                    day: true,
                    file: true,
                    zipCode: true
                }});

            const hasAnyError = some(this.state.errors, (eachFieldError) => {
                return !isEmpty(eachFieldError);
            });

            if(this.state.firstName !== this.props.userProfile.given_name || 
               this.state.lastName !== this.props.userProfile.family_name){                
                this.props.setNamesFromHistoryAndModified({fName:this.state.firstName,lName:this.state.lastName});
            }

            if(!hasAnyError) {
                this.props.setShowLoaderStatus(true);
                const payloadData = {
                    accountId:this.props.transactionId,
                    transactionId: this.props.transactionId,  // read like this one
                    transactionStatus: "inProgress",
                    firstName:  this.state.firstName,
                    middleName: "",
                    lastName:  this.state.lastName,
                    uid: this.props.userProfile.uid,
                    otherFirstName: this.state.otherFirstName,
                    otherLastName: this.state.otherLastName,
                    documentName: this.state.fileName,
                    document: this.state.file,
                    documentType: "",
                    dateofbirth: moment(`${this.state.dateOfBirth.day}-${this.state.dateOfBirth.month}-${this.state.dateOfBirth.year}`, 'DD-MM-YYYY').format("DD-MM-YYYY"),
                    dateOfBirth: this.state.dateOfBirth,
                    zipcode: this.state.zipCode
                }
                this.props.savePersonalInfo(payloadData,() =>{
                    this.props.history.push('/exam-details');
                });

            }
        });


        event.preventDefault();
    }


    setSuccessOrErrorClass(propName, ...rest) {
        let className = [rest[0].default || ''];
        if(this.state.isDirtyInput[propName]) {
            if(!isEmpty(this.state.errors[propName])) {
                className.push(rest[0].error || '');
            } else {
                className.push(rest[0].success || '');
            }
        }
        return className.join(' ');
    }

    setErrorAndDirtyFlag(validatorError, propName) {
        if(validatorError.length){
            this.setState({errors: {...this.state.errors, [propName]: validatorError[0]}});
        }

        this.setState({isDirtyInput: {...this.state.isDirtyInput, [propName]: true}});
    }

    checkDOB() {
        if(!isEmpty(this.state.dateOfBirth.day) && !isEmpty(this.state.dateOfBirth.month)
            && !isEmpty(this.state.dateOfBirth.year)) {
            const validatorError = formValidatorService.validate(this.state.dateOfBirth,
                ['validDate']);
            this.setState({errors: {...this.state.errors,
                    dateOfBirth: validatorError[0],
                    day: validatorError[0],
                    month: validatorError[0]
                }});
        }
    }

    reDirectToHistory = () => {
        this.props.resetPersonalInfoData();
        this.props.restExamDetails();
        this.props.restInstitutionDetails();
        this.props.history.push('/transcript-history')
    }

    render() {
        
        return (
            <div className="maindiv w-100">
                
                <StepForm pathname={this.props.location.pathname}></StepForm>
                <div className="personalInfo">
                    <div className="row">
                        <label><b className="personalInfolabel">Personal information</b><span className="required">*Required</span></label>
                    </div>
                    <div className="card personalInfoCard">
                        <form autoComplete="off">
                            <div className="card-body">

                                <div className="form-group col-12 col-lg-5 col-sm-6 col-md-5 mb-3">
                                    <label
                                        className={this.setSuccessOrErrorClass('firstName', {error: "errorLabel", success: "successLabel"})}>First name<span className="errorLabel">*</span></label>
                                    <input type="text" id="firstName" className={this.setSuccessOrErrorClass('firstName', {error: "errorMsg", success: "success", default: "form-control"})}
                                        value={(this.state.firstName)
                                            ? this.state.firstName : ''} onChange={(e)=>this.handleNameChange(e)} maxLength="255"></input>
                                    {this.state.isDirtyInput.firstName && this.state.errors.firstName.required &&
                                        <p className="text-danger">Please enter the student's first name</p>}

                                    {this.state.isDirtyInput.firstName && this.state.errors.firstName.alphaStringWithSpaceBetween &&
                                        <p className="text-danger">Please enter alphabet only</p>}
                                </div>
                                <div className="form-group col-12 col-lg-5 col-sm-6 col-md-5 mb-3">
                                    <label className={this.setSuccessOrErrorClass('lastName', {error: "errorLabel", success: "successLabel"})}>Last name<span className="errorLabel">*</span></label>
                                    <input type="text" id="lastName"
                                        className={this.setSuccessOrErrorClass('lastName', {error: "errorMsg", success: "success", default: "form-control"})}
                                        value={( this.state.lastName)
                                            ? this.state.lastName : ''}
                                        onChange={(e)=>this.handleLastNameChange(e)} maxLength="255"></input>
                                    {this.state.isDirtyInput.lastName && this.state.errors.lastName.required &&
                                        <p className="text-danger">Please enter the student's last name</p>}

                                    {this.state.isDirtyInput.lastName && this.state.errors.lastName.alphaStringWithSpaceBetween &&
                                        <p className="text-danger">Please enter alphabet only</p>}
                                </div>
                                <div className="form-group col-9 col-lg-4 col-sm-6 col-md-4 mb-3">
                                    <label>Other first name(s)</label>
                                    <input type="text" id="otherFirstName"
                                        className="form-control"
                                        value={this.state.otherFirstName}
                                        onChange={(e)=>this.handleOtherFirstNameChange(e)}
                                        placeholder="e.g. nickname" maxLength="255"></input>

                                    {this.state.isDirtyInput.otherFirstName && this.state.errors.otherFirstName.alphaStringWithSpaceBetween &&
                                        <p className="text-danger">Please enter alphabet only</p>}
                                </div>
                                <div className="form-group col-9 col-lg-4 col-sm-6 col-md-4 mb-3">
                                    <label>Other last name(s)</label>
                                    <input type="text" id="otherLastName"
                                        className="form-control"
                                        placeholder="e.g. maiden name"
                                        value={this.state.otherLastName}
                                        onChange={(e)=>this.handleOtherLastNameChange(e)} maxLength="255"></input>

                                    {this.state.isDirtyInput.otherLastName && this.state.errors.otherLastName.alphaStringWithSpaceBetween &&
                                        <p className="text-danger">Please enter alphabet only</p>}

                                </div>
                                <div>
                                    <div className="form-group col-12 col-lg-5 col-sm-6 col-md-5 mb-3">
                                        <label className="successLabel">Email</label>
                                        <input type="email" id="email" className="form-control bg-white email-inactive success" placeholder="example@gmail.com"  value={(this.state.email)
                                            ? this.state.email : ''} onChange={(e)=>this.handleEmailChange(e)} disabled></input>
                                    </div>
                                    <small className="form-text text-muted pl-3 mt-n3 mb-3">
                                        This is your account email address. You can change your account email in your <a href={process.env.REACT_APP_CAMBRIDGE_MYACCOUNT_URL}
                                            target="_blank"
                                            rel="noopener noreferrer">Account profile.</a> Your email will be sent with your transcript.
                                        </small>
                                </div>
                                <div>
                                    <span className="labels dobLabel">Date of birth<span className="errorLabel">*</span></span>

                                    <div className="row justify-content-between pl-3 dateOfBirth form-group col-12 col-lg-5 col-sm-6 col-md-5 mb-3 m-0">
                                        <div className="dob  col-3 col-lg-3 col-sm-3 col-md-3">
                                            <div className="select-form-group">
                                                <select id="day"
                                                    className={this.setSuccessOrErrorClass('day', {error: "errorMsg", success: "success", default: "form-control"})}
                                                    value={this.state.dateOfBirth.day} onChange={(e)=>this.handleBirthDayChange(e)}>
                                                    <option value=""  defaultValue>Day</option>
                                                    { UtilityService.getDayList().map(value => <option key={value} value={value}>{value}</option>) }
                                                </select>
                                            </div>
                                        </div>
                                        <div className="dob  col-5 col-lg-5 col-sm-5 col-md-5">
                                            <div className="select-form-group">
                                                <select id="month"
                                                    className={this.setSuccessOrErrorClass('month', {error: "errorMsg", success: "success", default: "form-control"})}
                                                    value={this.state.dateOfBirth.month} onChange={(e)=>this.handleBirthMonthChange(e)}>
                                                    <option value=""   defaultValue>Month</option>
                                                    { UtilityService.getListOfMonths().map(eachMonth => <option key={eachMonth.key} value={eachMonth.key}>{eachMonth.value}</option>) }
                                                </select>
                                            </div>
                                        </div>
                                        <div className="dob  col-4 col-lg-4 col-sm-4 col-md-4">
                                            <div className="select-form-group">
                                                <select id="year"
                                                    className={this.setSuccessOrErrorClass('year', {error: "errorMsg", success: "success", default: "form-control"})}
                                                    value={this.state.dateOfBirth.year} onChange={(e)=>this.handleBirthYearChange(e)}>
                                                    <option value=""  defaultValue>
                                                        Year
                                                        </option>
                                                    { UtilityService.getListOfYears().map(value => <option key={value} value={value}>{value}</option>) }
                                                </select>
                                            </div>
                                        </div>

                                    </div>
                                    {(this.state.errors.day.required || this.state.errors.month.required
                                        || this.state.errors.year.required) &&
                                        <p className="text-danger pl-3">Please select the student's date of birth</p>}
                                    {!(this.state.errors.day.required || this.state.errors.month.required
                                        || this.state.errors.year.required) &&
                                        this.state.errors.dateOfBirth.validDate &&
                                        <p className="text-danger pl-3">Date is not valid</p>}
                                    {this.state.errors.dateOfBirth.fiveYearPriorDate &&
                                        <p className="text-danger pl-3">Date of birth cannot be less than 5 years from the current date.</p>}
                                </div>
                                <div className="form-group col-9 col-lg-4 col-sm-6 col-md-4 mb-3">
                                    <label
                                        className={this.setSuccessOrErrorClass('zipCode', {error: "errorLabel", success: "successLabel"})}>Zip code<span className="errorLabel">*</span></label>
                                    <input type="text" id="zipCode" className={this.setSuccessOrErrorClass('zipCode', {error: "errorMsg", success: "success", default: "form-control"})}
                                        value={this.state.zipCode} onBlur={(e)=>this.showErrMsgs(e)}  onChange={(e)=>this.handleZipCodeChange(e)} minLength="5" maxLength="5"></input>
                                                                        
                                    {this.state.isDirtyInput.zipCode && this.state.errors.zipCode?.required &&
                                        <p className="text-danger">Please enter the zip code</p>}
                                    
                                    {this.state.isDirtyInput.zipCode && this.state.errors.zipCode?.zipCodeInvalid &&                                   
                                        <p className="text-danger">Please enter a valid zip code</p>}

                                </div>
                                <div className="form-group">
                                    <span className="identitylabel pl-4">Identification<span className="errorLabel">*</span></span>
                                    <div>
                                        <button type="button" id="file" className="btn btn-primary addFile mb-2" onClick={this.handleFileUpload} > <span className="fileUpload">    <span className="fileUpload"><FontAwesomeIcon icon={faUploadV5} /></span></span><span>Add file</span></button>
                                        <input type="file" style={{ display: 'none' }} id="fileupload" accept=".pdf, .jpeg, .jpg, .png, .webp" onChange={(e) => this.handleChange(e)} ></input>
                                        <span className="pl-3">{this.state.fileName}</span>
                                        {(!this.state.isCorruptedImg && this.state.previewSrc && !this.state.errors.file.profileFileTypeMismatch && !this.state.errors.file.fileSizeCheck) && <div>
                                            <div className="pl-3 mb-2 mr-2"><a href={this.state.previewSrc} onClick={(e) => this.handlePreview(e)} style={{ textDecoration: 'none' }}><img src={this.state.previewSrc} className='previewImg' alt="Uploaded ID proof preview"/></a></div>
                                        </div>}
                                        {(!this.state.isCorruptedPdf && this.state.pdfSrc && !this.state.errors.file.profileFileTypeMismatch && !this.state.errors.file.fileSizeCheck) && <div>
                                            <div className="pl-3 mb-2 mr-2"><a href={this.state.pdfSrc} onClick={(e) => this.handlePreview(e)} style={{ textDecoration: 'none' }}><canvas ref={this.canvasRef} className='previewPdf' /></a></div>
                                        </div>}
                                        {((!this.state.isCorruptedImg && this.state.previewSrc && !this.state.errors.file.profileFileTypeMismatch && !this.state.errors.file.fileSizeCheck) || (!this.state.isCorruptedPdf && this.state.pdfSrc && !this.state.errors.file.profileFileTypeMismatch && !this.state.errors.file.fileSizeCheck)) &&
                                            <div className="ml-3 previewNote">
                                                <div><FontAwesomeIcon icon={faInfoCircle} /></div>
                                                <div>
                                                    <div>Please <a href={this.state.previewSrc || this.state.pdfSrc} onClick={(e) => this.handlePreview(e)} style={{ textDecoration: 'underline' }}>click here</a> to preview and check the uploaded ID proof before proceeding.</div>
                                                    <div>Make sure that the ID details are clear and readable.</div>
                                                </div>
                                            </div>}
                                        {((this.state.isCorruptedImg || this.state.isCorruptedPdf) && !this.state.errors.file.emptyFileCheck && !this.state.errors.file.fileSizeCheck && !this.state.errors.file.profileFileTypeMismatch) && <div className="pl-3 mb-2 mr-2 mt-2 corruptedIDPreview"><img src='data:image/png;base64,INVALIDDATA' alt="Corrupted ID preview"/><span className='previewImgAltText'>We couldn't open your ID proof. It is possibly corrupt or damaged.</span></div>}
                                        {this.state.errors.file.required &&
                                            <p className="text-danger ml-3">Please upload the student's ID image</p>}

                                        {this.state.errors.file.profileFileTypeMismatch &&
                                            <p className="text-danger ml-3">Please make sure your file is less than 3 MB and one of the accepted file types.</p>}
                                        {this.state.errors.file.fileSizeCheck &&
                                            <p className="text-danger ml-3">Please make sure your file is less than 3 MB and one of the accepted file types.</p>}
                                        {this.state.errors.file.emptyFileCheck &&
                                            <p className="text-danger ml-3">There is a problem with this image file and it cannot be uploaded. Please select a different image that meets the requirements for file type and size.</p>}
                                    </div>

                                    <small className="form-text text-muted pl-3">
                                        File types accepted: PDF, JPEG, JPG, PNG or Android file. The maximum file size is 3MB.
                                   </small>
                                    <div className="InfoText">
                                        <small className="form-text text-muted pl-3">
                                            <p> Accepted forms of ID: </p>
                                            <p>- Passport</p>
                                            <p> - Birth certificate </p>
                                            <p> - State-issued driver's license, learner's permit or ID card </p>
                                        </small>
                                        <small className="form-text text-muted pl-3">
                                            Your ID is used to confirm your identity and will be deleted 30 days after completing your request.
                                        </small>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>

                </div>
                <div className="row">
                    <div className="col-xl-12 col-sm-12">
                        <button onClick={(e)=>this.handleSubmit(e)} id="save"
                            type="button" className="btn btn-primary SaveButton mr-3 font-weight-bold"><span>Save and continue</span></button>                        
                        <button id='cancel' onClick={this.reDirectToHistory} type="button" className="btn btn-link font-weight-bold text-decoration-none"><span>Cancel</span></button>                        
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        personalInfoFlag: state.stateTransition.isPersonalInfoCrossed,
        userProfile: state.currentUser.profile,
        modifiedNames: state.currentUser,
        UID: state.currentUser.UID || null,
        userAppProfileData: state.personalInfo,
        transactionId: state.commonData.transactionId,
        examCenterList: state.examDetailsInfo.examCenterApivalues,
        institutionList: state.institutesDetailsInfo.institutionApivalues,
        transcriptRates : state.reviewConfirm
    };
};

const mapDispatchToProps = {
    setCurrentUserData,
    setShowLoaderStatus,
    setPersonalInfoData,
    savePersonalInfo,
    setTransactionId,
    getExamCenters,
    getInstitutions ,   
    resetPersonalInfoData,
    restExamDetails,
    restInstitutionDetails,
    setNamesFromHistoryAndModified
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(PersonalInformationComp))
